import { Card, Grid, RadioButton, Spinner } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useUserSegmentations from 'modules/onboarding/hooks/userSegmentations/useUserSegmentations'
import { PricingBundlePlanStructure } from 'modules/onboarding/lib/pricing/types'

type Props = {
  bundlesStructure: PricingBundlePlanStructure
  selectedBundle: string
  selectBundle: (bundle: string) => void
  scrollableSectionRef: React.RefObject<HTMLElement>
}

const CustomHubCard = () => {
  const { navigation } = useNavigation()

  return (
    <Card to={navigation.upgradePlan.customBundles.fullPath()}>
      <Card.Title>{i18n.t('pricing_plans.hubs.bundles.custom_bundles.title')}</Card.Title>
      <Card.Description>
        {i18n.t('pricing_plans.hubs.bundles.custom_bundles.description')}
      </Card.Description>
      <Card.Link to={navigation.upgradePlan.customBundles.fullPath()}>
        {i18n.t('pricing_plans.hubs.bundles.custom_bundles.action')}
      </Card.Link>
    </Card>
  )
}

const BundleSelector = ({
  bundlesStructure,
  selectedBundle,
  selectBundle,
  scrollableSectionRef,
}: Props) => {
  const { hopesWithFactorial: recommendedBundle, loading: bundlesLoading } = useUserSegmentations()
  const isRecommendedBundle = (bundleName: string) => {
    return bundleName.toLowerCase().split(' ').join('_') === recommendedBundle
  }
  const onChange = (bundleName: string) => {
    scrollableSectionRef.current?.scrollIntoView({ behavior: 'smooth' })
    selectBundle(bundleName)
    track(trackingEvents.billing.viewedHub, {
      hub_name: bundleName,
      is_recommended: isRecommendedBundle(bundleName),
    })
  }

  const getAvailableBundles = () => {
    return bundlesStructure?.packs.map((bundle) => {
      return {
        title: bundle.title,
        description: bundle.description,
        recommended: !!recommendedBundle ? isRecommendedBundle(bundle.title) : false,
      }
    })
  }

  if (bundlesLoading) return <Spinner />

  return (
    <Grid variant="small">
      {getAvailableBundles().map((bundle) => (
        <Card
          key={bundle.title}
          onClick={() => {
            onChange(bundle.title)
          }}
        >
          <Card.Title
            action={
              <RadioButton
                size="medium"
                onChange={(e) => {
                  onChange(e.currentTarget.value)
                }}
                value={bundle.title}
                checked={bundle.title === selectedBundle}
              />
            }
          >
            {bundle.title}
          </Card.Title>
          <Card.Description>{bundle.description}</Card.Description>
        </Card>
      ))}
      <CustomHubCard />
    </Grid>
  )
}

export default BundleSelector
